export default __webpack_public_path__ + "static/illustration-content-logo.url-18b9f6bdc75acf4046a50120574e00df.svg";